import axios from "axios";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import {webDomain, mobileDomain} from "@/api/config";

const firebaseApiKey= 'AIzaSyAE2C0wsTXSG_FZN3Zp9TM7s4gOVhq8z38';
const firebaseUrl = 'https://minglemint.page.link';
const webUrl = mobileDomain;


const configShare = {
};



export default {
    methods: {
        returnShareConfig(type) {
            return configShare[type];
        },
    },
    getShareLink(path) {
        return webUrl + path;
    },
    createBranchLink({path = '', img = '', title= '', description= ''}) {
        let params = {
            branch_key: 'key_live_fFDpRoEYL8H8Y2jV4ReDAajlsxjGrlOq',
            data: {
                'deeplink_path': webUrl + path,
                "$og_image_url": img,
                '$og_title': title,
                "$og_description": description,
                $fallback_url: webUrl + path,
                $web_only: true,
                $mobile_web_only: true,
                $og_url: img,
                $twitter_title: title,
                $twitter_description: description,
                $twitter_image_url: img,
            },
        }
        const options = {
            method: 'POST',
            headers: {accept: 'application/json', 'content-type': 'application/json'},
            body: JSON.stringify(params)
        };

        return fetch('https://api2.branch.io/v1/url', options).then(response => response.json()).then(response => response.url)
            .catch(err => console.error(err));
    },
    makeFirebaseShortLink(shareData={path: '', img: '', title: '', description: ''}) {
        //let link = getShareLink(shareData.path);
        let link = webUrl + shareData.path;
        let imgUrl = encodeURIComponent(shareData.img);
        let linkTitle = encodeURIComponent(shareData.title);
        let linkDescription = encodeURIComponent(shareData.description);

        //`${firebaseUrl}?link=${link}&st=Zozimus (꿈의 재료)| 밍글민트(Minglemint NFT Marketplace)&sd=밍글민트(Minglemint NFT Marketplace)&si=${img}`;
        let longDynamicLink = `${firebaseUrl}?link=${link}`;
        if(!util.isEmpty(shareData.img)) {
            longDynamicLink += `&si=${imgUrl}`;
        }
        if(!util.isEmpty(shareData.title)) {
            longDynamicLink += `&st=${linkTitle}`;
        }
        if(!util.isEmpty(shareData.description)) {
            longDynamicLink += `&sd=${linkDescription}`;
        }
        console.log(longDynamicLink)
        let params = {
            "longDynamicLink": longDynamicLink,
            "suffix": {
                "option": "SHORT"
            }
        };
        return axios.post(`https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${firebaseApiKey}`, params, {headers: {Authorization: ''}}).then(async (res) =>  {
            if(util.isEmpty(res.data.shortLink)) {
                EventBus.$emit('apiLoading', false);
                return;
            }
            return res.data.shortLink;
        }).catch(error => {
            console.log(error);
        })
    },
}
